(function (ws) {
    'use strict';

    ws.views.vrfTableCommon = ws.views.handsOnTable.extend({

        notHeaderElements: [
            'id',
            'partNo',
            'mandatoryFields',
            'quantity',
            'lineVRF',
            'uid',
            'productType',
            'type',
            'isReadOnly'
        ],
        iconSignClass: 'icon-sign_minus',

        events: _.extend({}, ws.views.handsOnTable.prototype.events, {
            'click .vrf-filter': 'filterVRFTable',
            'wheel .htCore.comp-tbl-simple th': 'scrollingHeader'
        }),

        /**
         * Initializes the view
         */
        initialize: function() {
            ws.views.handsOnTable.prototype.initialize.call(this);
            this.selectedRows = [];
            this.selectedColumns = [];
            this.headerTypeData = [];
        },

        /**
         * Fetch new table data
         * @param {boolean} checkMandatory
         */
        fetchTableData: function (checkMandatory) {
            $(this.$tableContainer).hide();

            this.$apiError.hide();
            this.$vrfTab.removeClass('error');
            if (this.$vrfTable) {
                this.$tableSpinner.removeClass('fadeOut');
                this.collection.reset();
                this.collection.fetch().done(function (response) {
                    this.filterInitialCollection(response);
                    this.activeCollection.on('change', function (model) {
                        this.updateRow(model);
                    }.bind(this));
                    this.getColWidths(response);
                    this.getHeaderCols(response);
                    this.getCols(response);
                    this.$tableSpinner.addClass('fadeOut');
                    this.filterVRFCollection();
                    this.$vrfTable.updateSettings({data: this.activeCollection});
                    $('.vrf-table-quantity-warning').addClass('hide').hide();
                    _.each(this.activeCollection.models, (model) => {
                        if (model.get('quantity') > 1000) {
                            $('.vrf-table-quantity-warning').removeClass('hide').show();
                        }
                    });
                }.bind(this)).fail(function () {
                    this.$apiError.show();
                }.bind(this));
            } else {
                this.initializeTable(checkMandatory);
            }
        },

        /**
         * Re render table, on tab click
         */
        reRenderTable: function (tabClick) {
            this.pageYOffset = window.pageYOffset;
            this.$tableSpinner.removeClass('fadeOut');
            this.pageYOffset = window.pageYOffset;
            if (tabClick) {
                $('.applied-filters-vrf ul').empty();
            }

            //pushing rendering of container to bottom of callstack, otherwise HoT renders without proper height
            //causing all rows to render which causes performance issues for large tables
            setTimeout(function() {
                this.resizeContainer(this.activeCollection.length, true);
                $(this.$tableContainer).show(function() {
                    if (this.$vrfTable) {
                        this.$vrfTable.updateSettings({
                            colHeaders: this.colHeaders,
                            columns: this.cols,
                            colWidths: this.colWidths,
                            height: this.activeCollection.length < this.maxTableRowsToRender ? undefined : 500
                        });

                        if (isOrderEntrySite) {
                            this.mouseOverEvents();
                        }
                    }
                }.bind(this));
            }.bind(this), 500);
        },

        /**
         * Initialize Handsontable
         * @param {boolean} checkMandatory
         */
        initializeTable: function (checkMandatory) {
            this.collection.quoteId = $('#quoteCode').val();
            if ($('#waitShowCall').val() === 'false') {
                this.collection.fetch().done(function (data) {
                    if (data.data.length > 0) {
                        this.filterInitialCollection(data);
                        this.activeCollection.on('change', function (model) {
                            this.updateRow(model);
                        }.bind(this));

                        //If rendering table only to check for mandatory fields, then continue with check
                        if (checkMandatory) {
                            this.checkMandatoryFields();
                        }

                        this.$tableSpinner.addClass('fadeOut');
                    }

                    this.getColWidths(data);
                    this.getHeaderCols(data);
                    this.getCols(data);
                    this.renderTable(data);
                    this.clearFilters();
                }.bind(this));
            }
        },

        dropdownRender: function (attr, readOnly, instance, td, row, col, prop, value, cellProperties) {
            //all cell renderers need to be in pure JS. JQuery causes huge performance issues for large quotes in IE.
            Handsontable.dom.empty(td);
            let model = this.activeCollection.at(row);
            let selectedValue;
            let valueText;

            //dim cells that are not applicable to product
            if (value === null || value === undefined || cellProperties.readOnly) {
                td.className = 'htDimmed qut-vrf-dimmed';
                cellProperties.editor = false;
                cellProperties.readOnly = true;
                Handsontable.dom.empty(td);
                this.setCellReadOnlyClass(td, cellProperties.readOnly);
                return td;
            } else {
                selectedValue = model.get(attr) || ' ';
                valueText = document.createTextNode(selectedValue.charAt(0) + selectedValue.slice(1));
                td.className = 'vrf-renew';
                td.appendChild(valueText);
                if (attr === 'VRF_NEW_RENEW') {
                    let dropdownValues = value ? ['Y', 'N'] : ['', 'Y', 'N'];//Dropdown values for ReNewal Y N
                    cellProperties.source = dropdownValues;
                }

                this.setCellReadOnlyClass(td, cellProperties.readOnly);
                Handsontable.renderers.DropdownRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
            }
        },

        /**
         * Generate table columns from api response data
         * @param {Object} response
         */
        getCols: function (response) {
            var colAttribute;
            var colHeader = null;
            var colType = 'numeric';
            var colTypeRequired = '';
            var lineVrf = 0;
            this.oddRows = [];
            this.cols = [];
            var index = 0;
            this.headerTypeData = response.header;
            if (isOrderEntrySite) {
                this.cols[index] = {
                    data: this.attr('id'),
                    editor: false,
                    readOnly: true,
                    renderer: this.checkboxRender.bind(this, this.attr)
                };
                index++;
            }

            this.cols[index++] = {
                data: this.attr('id'),
                editor: false, //disable editing of first column,
                renderer: this.idRenderer.bind(this)
            };
            this.cols[index++] = {
                data: this.attr('partNo'),
                editor: false, //disable editing of first column
                renderer: this.partNoRenderer.bind(this)
            };
            this.cols[index++] = {
                data: this.attr('quantity'),
                editor: false,
                renderer: this.quantityRenderer.bind(this)
            };
            this.cols[index++] = {
                data: this.attr('lineVRF'),
                editor: false,
                renderer: this.headerRenderer.bind(this)
            };

            // Using only data[0] since we need to iterate only through the first
            // element of the object in order to create the columns.
            _.each(response.data[0], function (col, elem) {
                if (this.notHeaderElements.indexOf(elem) === -1) {

                    colHeader = _.find(response.header, function (header) {
                        return header.name === elem;
                    });

                    if (colHeader.name === 'VRF_BIDDESK_AMOUNT') {
                        colHeader.type = 'C';
                    }

                    colTypeRequired = colHeader ? colHeader.type : null;

                    switch (colTypeRequired) { // http://docs.handsontable.com/0.15.0-beta6/tutorial-cell-types.html
                        case 'N': // Numeric
                            colType = 'numeric';
                            break;
                        case 'D': // Date
                            colType = 'date';
                            break;
                        case 'C': // Character
                            colType = 'text';
                            break;
                        default:
                            colType = 'text';
                            break;
                    }

                    // For only Renewal field needs Dropdown and remaining fields are text fields
                    if (elem === 'VRF_NEW_RENEW') {
                        colAttribute = {
                            data: this.attr(elem),
                            type: 'dropdown',
                            renderer: this.dropdownRender.bind(this, elem, this.readOnly),
                            allowInvalid: true
                        };
                    } else {
                        colAttribute = {
                            data: this.attr(elem),
                            renderer: this.cellRenderer.bind(this),
                            type: colType,
                            allowInvalid: true,
                            cellKey: elem,
                            placeholder: elem,
                            placeholderCellClassName: 'placeholder'
                        };
                    }

                    if (this.readOnly === true) {
                        colAttribute.editor = false;
                    }

                    if (colType === 'date') {
                        colAttribute.type = 'date';
                        colAttribute.dateFormat = dateFormat;
                        colAttribute.datePickerConfig = {
                            yearRange: [2000, 2500]
                        };

                        colAttribute.correctFormat = true;
                        colAttribute.validator = this.customDateValidator;
                    }

                    this.cols.push(colAttribute);
                }
            }.bind(this));

            _.each(response.data, function(item) {
                //lineVrf
                if (item.lineVRF === true) {
                    lineVrf++;
                }

                //Create array of odd colored cells so they can get correct styling when rendered
                //This replaced actually merging cells, since cell merge along with vertical scrollbar did not actually limit the number of rows rendered
                if (lineVrf % 2) {
                    this.oddRows.push(item.uid);
                }

            }.bind(this));
        },

        checkboxRender: function (attr, instance, td, row) {
            // all cell renderers need to be in pure JS. JQuery causes huge performance issues for large quotes in IE.
            Handsontable.dom.empty(td);
            if (this.activeCollection.at(row).get('lineVRF')) {
                var docFragment = document.createDocumentFragment();

                var input = document.createElement('input');
                input.id = 'checkbox-' + row;
                input.className = 'custom-checkbox table-checkbox ';
                input.type = 'checkbox';

                input.setAttribute('data-id', row);

                if (attr) {
                    input.className = input.className + '-' + attr;
                }

                var label = document.createElement('label');
                label.htmlFor = 'checkbox-' + row;
                label.className = 'custom-checkbox-label dynamic-checkbox';

                Handsontable.dom.empty(td);
                docFragment.appendChild(input);
                docFragment.appendChild(label);

                td.appendChild(docFragment);
                td.className = 'checkbox';
                td.parentElement.setAttribute('data-id', row);
            }

            return td;
        },

        /**
         * Id Renderer
         * @param {Object} instance
         * @param {Object} td
         * @param {Function} row
         * @param {number} col
         * @param {Function} prop
         * @param {string} value
         * @param {Object} cellProperties
         * @returns {*}
         */
        idRenderer: function(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.dom.empty(td);

            var model = this.activeCollection.at(row);
            var isOddRow = this.oddRows.indexOf(model.get('uid'));
            var parent = td.parentNode;
            var isBundleChild = this.isBundleChild(model);

            parent.className = isOddRow >= 0 ? 'odd' : 'even';
            if (this.$vrfTable && this.$vrfTable !== null && this.$vrfTable.table !== null) {
                parent.setAttribute('data-id', this.$vrfTable.toPhysicalRow(row));
            }

            if (model.get('lineVRF') || isBundleChild || this.isFilteringQty()) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
            }

            return td;
        },

        /**
         * Item Renderer
         * @param {Object} instance
         * @param {Object} td
         * @param {Function} row
         * @param {number} col
         * @param {Function} prop
         * @param {string} value
         * @param {Object} cellProperties
         * @returns {*}
         */
        quantityRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            cellProperties.readOnly = true;
            td.innerHTML = value;
            return td;
        },

        /**
         * PartNo Renderer
         * @param {Object} instance
         * @param {Object} td
         * @param {Function} row
         * @param {number} col
         * @param {Function} prop
         * @param {string} value
         * @param {Object} cellProperties
         * @returns {*}
         */
        partNoRenderer: function(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.dom.empty(td);
            var model = this.activeCollection.at(row);
            var isBundleChild = this.isBundleChild(model);
            var valueText = document.createTextNode(value);

            if (model.get('lineVRF') || isBundleChild || this.isFilteringQty()) {

                if (this.isBundleParent(model)) {
                    this.createBundleIconElement(td, model.get('id'), this.iconSignClass, true);
                }

                td.appendChild(valueText);

                if (isBundleChild) {
                    td.className = 'item-bundle-child';
                }
            }

            return td;
        },

        /**
         * Header Renderer
         * @param {Object} instance
         * @param {Object} td
         * @param {Function} row
         * @param {number} col
         * @param {Function} prop
         * @param {string} value
         * @param {Object} cellProperties
         * @returns {*}
         */
        headerRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            Handsontable.dom.empty(td);
            var valueText;

            //TODO: should be pulled from properties files
            if (value === true) {
                valueText = document.createTextNode('Item');
            } else {
                valueText = document.createTextNode('Quantity');
            }

            td.appendChild(valueText);
            return td;
        },

        vrfDateRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.DateRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
            if (value && moment(value, dateFormat).year() >= 2000) {
                cellProperties.defaultDate = value;
            } else {
                cellProperties.defaultDate = '';
            }
        },

        /**
         * Handsontable cell renderer to disable disabled vrf fields
         * @param {Object} instance
         * @param {Object} td
         * @param {Function} row
         * @param {number} col
         * @param {Function} prop
         * @param {string} value
         * @param {Object} cellProperties
         */
        cellRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            var mandatory = false;
            var cellKey = cellProperties.cellKey;
            var mandatoryFields = this.activeCollection.models[row].attributes.mandatoryFields; //instance.getSourceData().models[row].attributes.mandatoryFields;
            var cell = {row: row, col: col};
            var model = this.activeCollection.models[row]; //instance.getSourceData().models[row];
            var cellType = this.headerTypeData.find(item => item.name === cellKey);
            var addErr = _.where(model.get('errorCells'), cell) > 0;
            var valueText;

            //add error class to error cell
            if (addErr) {
                setTimeout(function () {
                    td.className = 'error';
                }.bind(this), 100);
            }

            if (mandatoryFields && mandatoryFields.indexOf(cellKey) >= 0) {
                mandatory = true;
            }

            cellProperties.readOnly = this.isCellReadOnly(model, 'VRF');

            //dim cells that are not applicable to product
            if (value === null || value === undefined || cellProperties.readOnly) {
                td.className = 'htDimmed qut-vrf-dimmed';
                cellProperties.editor = false;
                cellProperties.readOnly = true;
                Handsontable.dom.empty(td);
            } else if ($.trim(value).length <= 0) {
                //add placeholder value empty cells
                Handsontable.dom.empty(td);
                var colHeader = instance.getColHeader(col);
                valueText = document.createTextNode(colHeader.split('>')[colHeader.split('>').length - 1]);
                td.className = 'placeholder';

                if (mandatory) {
                    valueText = document.createTextNode('*' + colHeader.split('>')[colHeader.split('>').length - 1]);
                    td.className = 'mandatory';
                    cellProperties.isMandatory = true;
                }

                td.appendChild(valueText);
            }

            if (cellType.type === 'D') {
                if (value && moment(value, dateFormat).year() >= 2000) {
                    cellProperties.defaultDate = value;
                } else {
                    cellProperties.defaultDate = '';
                }
            }

            if (cellKey === 'VRF_CSC_MSE') {
                cellProperties.readOnly = true;
            }

            if (['VRF_BILLING_PLAN_TYPE', 'VRF_BILLING_SEQUENCE', 'VRF_NO_OF_MONTHS_TOTAL'].includes(cellKey) && model.attributes.isReadOnly) {
                td.className = 'htDimmed';
                cellProperties.editor = false;
                cellProperties.readOnly = true;
            }

            return td;
        },

        /**
         * checks if the table is being filtered by quantity
         */
        isFilteringQty: function() {
            return !this.$filterItems.is(':checked') && this.$filterQty.is(':checked');
        },

        /**
         * checks if the table is being filtered by line items
         */
        isFilteringLineItems: function() {
            return this.$filterItems.is(':checked') && !this.$filterQty.is(':checked');
        },

        /**
         * checks if there is no filter applied
         */
        isNotFiltering: function() {
            return this.$filterItems.is(':checked') && this.$filterQty.is(':checked') || !this.$filterItems.is(':checked') && !this.$filterQty.is(':checked');
        },

        /**
         * uncheck the table filters
         */
        clearFilters: function() {
            this.$filterItems.prop('checked', false);
            this.$filterQty.prop('checked', false);
        },

        /**
         * display VRF filter panel
         */
        showVRFFilter: function(e) {
            e.preventDefault();
            e.stopPropagation();
            this.$filterPanel.toggle();
        },

        /**
         * hide VRF filter panel on body click
         */
        hideVRFFilter: function() {
            //this.$filterPanel.hide();
        },

        /**
         * handles scrolling over the header if the table doesn't have scrollbar
         * @param {Object} e
         */
        scrollingHeader: function(e) {
            if (this.collection.length > this.maxRowsWithoutScroll) {
                window.scrollBy(0, e.originalEvent.deltaY);
            }
        },

        /**
         * On Scroll: show/hide persistent table header
         */
        onScrollVRF: function() {
            this.onScroll();
        },

        /**
         * On Scroll: show/hide persistent table header
         */
        onScroll: function() {

            if (this.$table) {

                //check visibility
                var isTHeadVisible = this.isScrolledIntoView(this.$thead, this.$thead.height());
                var isLastRowVisible = this.isScrolledIntoView(this.$lastRow, this.stickyHeight);
                var isFixed = !isTHeadVisible && isLastRowVisible;
                var isDefault = (!isTHeadVisible && !isLastRowVisible) || isTHeadVisible;

                var fixedCss = {
                    top: this.stickyHeight,
                    left: this.tableLeftPostion
                };

                this.$htCloneTop.toggleClass('fixed-header', isFixed);
                this.$htCloneTopLeft.toggleClass('fixed-header', isFixed);
                this.$htCloneTop.toggleClass('default-header', isDefault);
                this.$htCloneTopLeft.toggleClass('default-header', isDefault);

                if (isFixed) {
                    this.$htCloneTop.css(fixedCss);
                    this.$htCloneTopLeft.css(fixedCss);
                }
            }
        },

        /**
         * Check if element has scrolled off the top and is no longer visible
         * @param {Object} elem
         * @param {number} offset - used if need to check if element has scrolled behind another element at the stop, in this case the sticky component
         */
        isScrolledIntoView: function(elem, offset) {
            // var topOffset = offset || 0;
            // var docViewTop = $(window).scrollTop() + topOffset;
            // var elemTop = $(elem).offset().top + $(elem).height();
            // return ((elemTop >= docViewTop));
        },

        /**
         * filter VRF table to display the line/qty items
         */
        filterVRFTable: function() {
            this.filterVRFCollection();
            this.reRenderTable();
        },

        /**
         * Filter initial dataset to avoid more than 500 qty items on each product
         * @param {Object} data
         */
        filterInitialCollection: function(data) {

            var groupedCollection = _.groupBy(data.data, 'id');
            var auxCollection = [];

            _.each(groupedCollection, function(product) {

                //filter QTY lines if they are more than 500, plus 1 is for lineVRF itself
                if (product.length > 1001) {
                    auxCollection = auxCollection.concat(_.filter(product, function(rows) {
                        return rows.lineVRF === true;
                    }.bind(this)));
                }
                else {
                    auxCollection = auxCollection.concat(product);
                }
            }.bind(this));

            this.collection.reset(auxCollection);
            this.activeCollection = new ws.collections.vrfTableCollection(this.collection.models);
        },

        /**
         * filter VRF collection and updates the data property of the table
         */
        filterVRFCollection: function() {
            if (this.isFilteringLineItems()) {
                this.activeCollection = new ws.collections.vrfTableCollection(this.collection.where({ lineVRF: true }));
            } else if (this.isFilteringQty()) {
                this.activeCollection = new ws.collections.vrfTableCollection(this.collection.where({ lineVRF: false }));
            } else {
                this.activeCollection = new ws.collections.vrfTableCollection(this.collection.models);
            }

            this.$vrfTable.updateSettings({data: this.activeCollection});
        },

        /**
         * Check for missing mandatory fields. (Fetch table and render it if not done so already)
         */
        triggerMandatoryFieldCheck: function () {
            westcon.amQuoteDetailPendingAjaxCall = $.Deferred();

            if (this.$vrfTable) {
                this.checkMandatoryFields();
            } else {
                this.fetchTableData(true);
            }
        },

        /**
         * Check that all mandatory fields are populated
         */
        checkMandatoryFields: function () {
            var error = this.hasCellErrors();
            var cell;

            _.each(this.activeCollection.models, function(model) {
                if (model.get('lineVRF')) {
                    var mandatoryFields = model.get('mandatoryFields');
                    var modelErrors = model.get('errorCells');

                    _.each(mandatoryFields, function(field) {

                        if ($.trim(model.get(field)).length === 0) {
                            cell = {
                                row: model.get('uid') - 1,
                                col: this.colHeaderOrder.indexOf(field)
                            };

                            //avoid error cell duplication, add it only if it's not in the array
                            if (_.where(modelErrors, cell).length === 0) {
                                modelErrors = modelErrors.concat(cell);
                                model.set('errorCells', modelErrors, {silent:true});
                            }

                            error = true;
                        }
                    }.bind(this));
                }
            }.bind(this));

            if (isOrderEntrySite && $('#subscriptionOrder').val() === 'true' && $('#vpsOrderRequestByRenewal').val() === 'true') {
                this.showRenewErroronVrfTable();
            }

            if (this.hasCellErrors()) {
                this.$genericError.show().removeClass('hide');
                this.$vrfTable.render();
            }

            this.eventAgg.trigger('returnVRFTableError', error);
            westcon.amQuoteDetailPendingAjaxCall.resolve();
        },

        /**
         * Add cell to errorCells array
         * @param {Object} cell
         * @param {Object} model
         */
        addCellToArray: function(cell, model) {
            var modelErrors = model.get('errorCells');

            if (_.where(modelErrors, cell).length === 0) {
                model.set('errorCells', modelErrors.concat(cell), {silent:true});
            }
        },

        /**
         * Pushes the invalid date cell and splice the valid one and call the date error display method
         * @param {Object} startDateCell
         * @param {Object} endDateCell
         * @param {Bool} isStartDateValid
         * @param {Bool} isEndDateValid
         */
        handleDateInvalid: function(startDateCell, endDateCell, isStartDateValid, isEndDateValid, model) {

            if (isStartDateValid && !isEndDateValid) {
                this.addCellToArray(endDateCell, model);
                this.removeCellFromArray(startDateCell, model);
            }

            if (!isStartDateValid && isEndDateValid) {
                this.addCellToArray(startDateCell, model);
                this.removeCellFromArray(endDateCell, model);
            }

            if (!isStartDateValid && !isEndDateValid || isStartDateValid && isEndDateValid && this.isInvalidLicenseDate) {
                this.addCellToArray(startDateCell, model);
                this.addCellToArray(endDateCell, model);
            }

            if (isStartDateValid && isEndDateValid && !this.isInvalidLicenseDate) {
                this.removeCellFromArray(startDateCell, model);
                this.removeCellFromArray(endDateCell, model);
            }

            this.handleInvalidDateMsg();

        },

        /**
         * Handles the display of the date's error messages
         */
        handleInvalidDateMsg: function() {
            var nonLicenseDateErrors = this.getNonLicenseDateErrors();

            this.$licenceDateError.toggle(this.isInvalidLicenseDate && !this.isInvalidDate);
            this.$genericError.toggle(nonLicenseDateErrors.length !== 0 || this.isInvalidDate);
        },

        /**
         * Remove cell from errorCells array
         * @param {Object} cell
         * @param {Object} model
         */
        removeCellFromArray: function(cell, model) {
            var modelErrors = _.clone(model.get('errorCells'));
            var indexOfEditedCellInModel = _.findIndex(modelErrors, cell);

            if (indexOfEditedCellInModel !== -1) {
                modelErrors.splice(indexOfEditedCellInModel, 1);
                model.set('errorCells', modelErrors, {silent:true});
            }
        },

        /**
         * validate licence start and end date
         * @param {Object} model
         */
        validateDate: function(model, date, selectedDate) {
            var startDate = (selectedDate === this.startDateCellName) ? date : model.get(this.startDateCellName);
            var endDate = (selectedDate === this.endDateCellName) ? date : model.get(this.endDateCellName);
            var isStartDateValid = this.customDateValidator(startDate);
            var isEndDateValid = this.customDateValidator(endDate);
            var startDateCell = {
                row: model.get('uid') - 1,
                col: this.colHeaderOrder.indexOf(this.startDateCellName)
            };
            var endDateCell = {
                row: model.get('uid') - 1,
                col: this.colHeaderOrder.indexOf(this.endDateCellName)
            };

            var startDateToCompare = moment(startDate, dateFormat);
            var endDateToCompare = moment(endDate, dateFormat);
            this.isInvalidLicenseDate = startDateToCompare >= endDateToCompare;
            this.$licenceDateError.hide();
            this.isInvalidDate = !isStartDateValid || !isEndDateValid;
            this.handleDateInvalid(startDateCell, endDateCell, isStartDateValid, isEndDateValid, model);

            //toggle table errors
            this.showVRFHeaderErrors(this.hasCellErrors());

            //reseting invalid change after error handling
            this.invalidChange = false;

            if (this.isInvalidLicenseDate) {
                if (selectedDate === this.startDateCellName) {
                    model.set(this.startDateCellName, date, {silent: true});
                }

                if (selectedDate === this.endDateCellName) {
                    model.set(this.endDateCellName, date, {silent: true});
                }
            }

            if (!this.isInvalidLicenseDate) {
                if (selectedDate === this.startDateCellName) {
                    model.set(this.startDateCellName, date);
                }

                if (selectedDate === this.endDateCellName) {
                    model.set(this.endDateCellName, date);
                }
            }

            return this.isInvalidLicenseDate;
        },

        /**
         * Update VRF row
         * @param {Object} model
         */
        updateRow: function (model) {

            var editedCol = Object.keys(model.changedAttributes())[0]; //get name of last edited column
            var cell = {row: this.editedRow, col: this.editedCol};
            var isErrorCell;

            //If product has a start & end licence date, validate the dates
            if (editedCol === this.startDateCellName || editedCol === this.endDateCellName) {
                this.validateDate(model);
            }

            if (isOrderEntrySite && $('#subscriptionOrder').val() === 'true' && $('#vpsOrderRequestByRenewal').val() === 'true') {
                this.updateRowRenewError(model);
                isErrorCell = _.where(model.get('errorCells'), cell).length > 0;
            } else {
                //Forcely making the save call on change of RENEW dropdown
                isErrorCell = _.where(model.get('errorCells'), cell).length > 0;
                if (editedCol === 'VRF_NEW_RENEW' && isErrorCell) {
                    isErrorCell = false;
                }
            }

            if (($('#subscriptionOrder').val() === 'true') && (model.get('type') === 'SUBSCRIPTION') && (!['VRF_NO_OF_MONTHS', 'VRF_LIC_END_DATE'].includes(editedCol))) {
                this.$tableSpinner.removeClass('fadeOut');
            }

            if (($('#cloudAnnuityOrder').val() === 'true') && ['FULL_TERM_ITEM', 'FULL_TERM_ITEM_PARENT', 'FULL_TERM_ITEM_CHILD'].includes(model.get('type')) && (!['VRF_NO_OF_MONTHS', 'VRF_LIC_END_DATE'].includes(editedCol))) {
                this.$tableSpinner.removeClass('fadeOut');
            }

            //don't save if is error cell
            if (!isErrorCell) {
                model.set('orderNumber', this.orderId, {silent:true});
                model.set('editedVRFColoumn', editedCol, {silent:true});
                if (this.isMultipleCallRequired) {
                    model.save(null, {silent: true}).done(function (data) {
                        if (this.matchedMapping ? this.matchedMapping.length : false) {
                            const currentModel = this.collection.models.filter((mod) => {
                                if (mod.get('id') === model.get('id') && mod.get('lineVRF')) {
                                    return mod;
                                }
                            });

                            if (this.matchedMapping[model.get('id') / 10 - 1]) {
                                if (this.matchedMapping[model.get('id') / 10 - 1].qntMatchingFields ? this.matchedMapping[model.get('id') / 10 - 1].qntMatchingFields.includes(editedCol) : false) {
                                    this.matchedMapping[model.get('id') / 10 - 1].qntyMatch = false;
                                    $(this.$vrfTable.getCell(currentModel[0].get('uid') - 1, 2, true)).removeClass('highlightCell');
                                }
                            }
                        }

                        this.editedRow = this.activeCollection.indexOf(model);
                        if (($('#subscriptionOrder').val() === 'true') && (model.get('type') === 'SUBSCRIPTION') && (!['VRF_NO_OF_MONTHS', 'VRF_LIC_END_DATE'].includes(editedCol))) {
                            this.eventAgg.trigger('fetchVRFTableData');
                            this.$tableSpinner.addClass('fadeOut');
                            setTimeout(function() {
                                $('.qut-vrf-tab-link').trigger('click');
                            }, 500);
                        } else if (($('#cloudAnnuityOrder').val() === 'true') && ['FULL_TERM_ITEM', 'FULL_TERM_ITEM_PARENT', 'FULL_TERM_ITEM_CHILD'].includes(model.get('type')) && (!['VRF_NO_OF_MONTHS', 'VRF_LIC_END_DATE'].includes(editedCol))) {
                            this.eventAgg.trigger('fetchVRFTableData');
                            this.$tableSpinner.addClass('fadeOut');
                            setTimeout(function() {
                                $('.qut-vrf-tab-link').trigger('click');
                            }, 500);
                        } else if (data.duration || data.refreshGrid) {
                            this.eventAgg.trigger('refreshQuoteProductCart', true, true);
                        }

                        this.removeErrorFromCell();
                    }.bind(this)).fail(function() {
                        this.addErrorToCell();
                        this.$tableSpinner.addClass('fadeOut');
                    }.bind(this));

                }
            }
        },

        /**
         * check if the cell is a date cell
         * @param {Object} cell
         */
        isLicenseDateCell: function(cell) {
            var isStartDateCell = cell.col === this.colHeaderOrder.indexOf(this.startDateCellName);
            var isEndDateCell = cell.col === this.colHeaderOrder.indexOf(this.endDateCellName);

            return isStartDateCell || isEndDateCell;
        },

        /**
         * Return value of cell to render
         * @param {model} at
         * @returns {Function}
         */
        attr: function (at) {
            // this lets us remember `attr` for when when it is get/set
            /**
             * Function
             */
            return function (model, value) {

                if (_.isUndefined(value)) {
                    value = model.get(at);
                    return value;
                }

                model.set(at, value);
            };
        },

        /**
         * Remove error from cell
         */
        removeErrorFromCell: function (cell) {
            this.invalidChange = false;
            cell = (cell) ? cell : {row: this.editedRow, col: this.editedCol};
            var currentCell = this.$vrfTable.getCell(cell.row, cell.col, true);
            var model = this.activeCollection.at(cell.row);
            var modelCellErrors = _.clone(model.get('errorCells'));
            var indexOfEditedCellInModel = _.findIndex(modelCellErrors, cell);

            if (!this.isLicenseDateCell(cell)) {
                if (indexOfEditedCellInModel !== -1) {
                    $(currentCell).removeClass('error');
                    modelCellErrors.splice(indexOfEditedCellInModel, 1);
                    model.set('errorCells', modelCellErrors, {silent:true});
                }

                this.showVRFTableErrors();
            }
        },

        /**
         * Add error to cell
         */
        addErrorToCell: function (row, col) {
            var currentCell = this.$vrfTable.getCell(row ? row : this.editedRow, col ? col : this.editedCol, true);
            var cell = {
                row: row || row === 0 ? row : this.editedRow,
                col: col ? col : this.editedCol
            };
            var model = this.activeCollection.at(cell.row);
            var modelCellErrors = model.get('errorCells');
            var isErrorCell = _.where(modelCellErrors, cell).length > 0;

            $(currentCell).addClass('error');

            if (!isErrorCell) {
                model.set('errorCells', modelCellErrors.concat(cell), {silent:true});
            }

            this.showVRFTableErrors();
        },

        /**
         * Date Validator
         */
        customDateValidator: function (value, callback) {
            var dateArray = [dateFormat];
            var isPositiveDate = value ? moment(value, dateArray, true).isValid() : true;

            if (callback) {
                callback(isPositiveDate);
            }
            else {
                return isPositiveDate;
            }
        },

        /**
         * Get column widths
         * @param {Object} response
         */
        getColWidths: function (response) {
            var customColSizes = _.map(response.header, function (column) {
                return (column.value && column.value.length > 10) ? column.value.length + 220 : 200;
            });

            if (isOrderEntrySite) {
                this.colWidths = [].concat([50, 80, 200, 60, 150], customColSizes, [200, 200]);
            } else {
                this.colWidths = [].concat([80, 200, 60, 150], customColSizes, [200, 200]);
            }
        },

        /**
         * Check if any model in the active collection has error cell
         */
        hasCellErrors: function() {
            return _.filter(this.activeCollection.models, function(model) {
                    return model.get('errorCells').length > 0;
                }).length > 0;
        },

        /**
         * retrieves the errors cells that don't belong to license date errors
         */
        getNonLicenseDateErrors: function() {
            var nonLicenseDateErrors = [];
            _.each(this.activeCollection.models, function(model) {
                var aux = _.filter(model.get('errorCells'), function(cell) {
                    return !this.isLicenseDateCell(cell);
                }.bind(this));
                if (aux.length > 0) {
                    nonLicenseDateErrors = nonLicenseDateErrors.concat(aux);
                }
            }.bind(this));

            return nonLicenseDateErrors;
        },

        /**
         * Resize table container based on number of rows to render
         * @param {number} rowLen - Number of rows in table
         */
        resizeContainer: function (rowLen, reRenderGrid) {
            if (this.$vrfTable && this.$vrfTable !== null && this.$vrfTable.table !== null) {
                let containerHeight = 0;
                let rows = reRenderGrid ? (rowLen > 20 ? 20 : rowLen) : (this.$vrfTable.countRows() > 20 ? 20 : this.$vrfTable.countRows());
                let tableHeaderHeight = 150;
                let rowHeight = 35;
                containerHeight = rows * rowHeight + tableHeaderHeight;
                this.$container.height(containerHeight);
                this.$vrfTable.updateSettings({height: containerHeight});
            }
        },

        mouseOverEvents: function () {
            this.$container.on('mouseover', '.tooltip-target', this.tableHoverEvents.bind(this));
        },

        /**
         * toggle tab errors and submit button
         */
        showVRFHeaderErrors: function(errors) {
            this.$vrfTab.toggleClass(this.errorClass, errors);
            this.$actionButton.prop('disabled', errors);
        },

        /**
         * Show table errors
         */
        showVRFTableErrors: function () {
            const nonLicenseDateErrors = this.getNonLicenseDateErrors();
            this.eventAgg.trigger('returnVRFTableError', this.hasCellErrors());
            this.$genericError.toggle(nonLicenseDateErrors.length > 0 || this.isInvalidDate === true); //checking for equal type as can be undefined
        },

        /**
         * Add error class to each cell in error array
         */
        updateErrorClass: function () {
            // Vrf tab grid not loading completely when tab is hidden. Ugly fix
            if ($('.comp-quote-vrf-table').css('display') === 'none' && $('.pricing-tab').hasClass('selected')) {
                $('.comp-quote-vrf-table').css('display', 'block');
                $('.tab-content[data-tab="vrf"]').css('display', 'block');
            }

            if ($('.comp-quote-vrf-table .comp-tbl-simple tbody tr').length) {
                var errorCell;
                _.each(this.activeCollection.models, function (model, index) {
                    _.each(model.get('errorCells'), function(cell) {
                        errorCell = this.$vrfTable.getCell(index, cell.col, true);
                        $(errorCell).addClass('error');
                    }.bind(this));
                }.bind(this));
            }

            // Vrf tab grid not loading completely when tab is hidden. Ugly fix
            if ($('.pricing-tab').hasClass('selected')) {
                $('.comp-quote-vrf-table').css('display', 'none');
                $('.tab-content[data-tab="vrf"]').css('display', 'none');
            }
        },

        updateRowRenewError: function(model) {
            var editedCol = Object.keys(model.changedAttributes())[0]; //get name of last edited column
            var cell = {row: this.editedRow,  col: this.colHeaderOrder.indexOf('VRF_NEW_RENEW')};
            $('.vrf-renew-error-div').html('');
            if (model.get('VRF_VENDOR_QUOTE_NUMBER')) {
                if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                    $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WITH INPUT IN THE VRF_PRIOR CONTRACT</span>').show();
                    this.addErrorToCellForRenew(cell.row, cell.col);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' && model.get('VRF_NEW_RENEW') === 'Y') {
                    $('.vrf-renew-error-div').append('<span>PLEASE PROVIDE THE PRIOR CONTRACT ID INTO THE VRF FIELD, AS AN E QUOTE UNDER RENEWAL Y IS NOT ALLOWED WITHOUT THE CONTRACT DATA</span>').show();
                    this.addErrorToCellForRenew(cell.row, cell.col);

                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' || String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) === 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                    //$('.vrf-renew-error-div').append('<span></span>').hide();
                    this.removeErrorFromCellRenew(cell);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                    //$('.vrf-renew-error-div').append('<span></span>').hide();
                    this.removeErrorFromCellRenew(cell);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                    //$('.vrf-renew-error-div').append('<span></span>').hide();
                    this.removeErrorFromCellRenew(cell);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                    $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WITH AN "R" QUOTE</span>').show();
                    this.addErrorToCellForRenew(cell.row, cell.col);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' || String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) === 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                    //$('.vrf-renew-error-div').append('<span></span>').hide();
                    this.removeErrorFromCellRenew(cell);
                } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' && model.get('VRF_NEW_RENEW') === 'N') {
                    $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WHEN USING AN "R" QUOTE.</span>').show();
                    this.addErrorToCellForRenew(cell.row, cell.col);
                }
            }
        },

        showRenewErroronVrfTable: function() {
            $('.vrf-renew-error-div').html('');
            let allArraySame = [];
            let errorDisplayed = false;

            _.each(this.activeCollection.models, (model, i) => {
                if (model.get('VRF_NEW_RENEW') !== null && model.get('VRF_NEW_RENEW') !== undefined && model.get('VRF_NEW_RENEW') !== '') {
                    allArraySame.push(model.get('VRF_NEW_RENEW'));
                }

            });
            let isallEqual = this.allEqualRenew(allArraySame);
            if (isallEqual) {
                _.each(this.activeCollection.models, (model, i) => {
                    var cell = {
                        row: model.get('uid') - 1,
                        col: this.colHeaderOrder.indexOf('VRF_NEW_RENEW')
                    };

                    if (model.get('VRF_VENDOR_QUOTE_NUMBER')) {
                        if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                            if (!errorDisplayed) {
                                $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WITH INPUT IN THE VRF_PRIOR CONTRACT</span>').show();
                                errorDisplayed = true;
                            }

                            this.addErrorToCellForRenew(cell.row, cell.col);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' && model.get('VRF_NEW_RENEW') === 'Y') {
                            if (!errorDisplayed) {
                                $('.vrf-renew-error-div').append('<span>PLEASE PROVIDE THE PRIOR CONTRACT ID INTO THE VRF FIELD, AS AN E QUOTE UNDER RENEWAL Y IS NOT ALLOWED WITHOUT THE CONTRACT DATA</span>').show();
                                errorDisplayed = true;
                            }

                            this.addErrorToCellForRenew(cell.row, cell.col);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' || String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) === 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                            this.removeErrorFromCellRenew(cell);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                            this.removeErrorFromCellRenew(cell);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                            this.removeErrorFromCellRenew(cell);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') !== '' && String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) !== 'null') && model.get('VRF_NEW_RENEW') === 'N') {
                            if (!errorDisplayed) {
                                $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WITH AN "R" QUOTE</span>').show();
                                errorDisplayed = true;
                            }

                            this.addErrorToCellForRenew(cell.row, cell.col);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && (model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' || String(model.get('VRF_PRIOR_CONTRACT_NUMBER')) === 'null') && model.get('VRF_NEW_RENEW') === 'Y') {
                            this.removeErrorFromCellRenew(cell);
                        } else if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('R') && model.get('VRF_PRIOR_CONTRACT_NUMBER') === '' && model.get('VRF_NEW_RENEW') === 'N') {
                            if (!errorDisplayed) {
                                $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE N WITH AN "R" QUOTE</span>').show();
                                errorDisplayed = true;
                            }

                            this.addErrorToCellForRenew(cell.row, cell.col);
                        }
                    }
                });
            } else {
                _.each(this.activeCollection.models, (model, i) => {
                    var cell = {
                        row: model.get('uid') - 1,
                        col: this.colHeaderOrder.indexOf('VRF_NEW_RENEW')
                    };

                    if (!errorDisplayed) {
                        if (model.get('VRF_VENDOR_QUOTE_NUMBER').startsWith('E')) {
                            $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE MIXED VALUE</span>').show();
                            errorDisplayed = true;
                        } else {
                            $('.vrf-renew-error-div').append('<span>VRF_RENEWAL CANNOT BE MIXED VALUE, MUST BE Y WITH AN "R" QUOTE</span>').show();
                            errorDisplayed = true;
                        }
                    }

                    if (model.get('VRF_NEW_RENEW') !== null && model.get('VRF_NEW_RENEW') !== undefined && model.get('VRF_NEW_RENEW') !== '') {
                        this.addErrorToCellForRenew(cell.row, cell.col);
                    }
                });

            }
        },

        addErrorToCellForRenew: function (row, col) {
            var currentCell = this.$vrfTable.getCell(row ? row : this.editedRow, col ? col : this.editedCol, true);
            var cell = {
                row: row || row === 0 ? row : this.editedRow,
                col: col ? col : this.editedCol
            };

            var model = this.activeCollection.at(cell.row);
            var modelCellErrors = model.get('errorCells');
            var isErrorCell = _.where(modelCellErrors, cell).length > 0;
            $(currentCell).addClass('error');
            if (!isErrorCell) {
                model.set('errorCells', modelCellErrors.concat(cell), {silent:true});
            }
        },

        removeErrorFromCellRenew: function (cell) {
            this.invalidChange = false;
            cell = (cell) ? cell : {row: this.editedRow, col: this.editedCol};
            var model = this.activeCollection.at(cell.row);
            var modelCellErrors = _.clone(model.get('errorCells'));
            var indexOfEditedCellInModel = _.findIndex(modelCellErrors, cell);
            if (!this.isLicenseDateCell(cell)) {
                if (indexOfEditedCellInModel !== -1) {
                    var currentCell = this.$vrfTable.getCell(cell.row, cell.col, true);
                    $(currentCell).removeClass('error');
                    modelCellErrors.splice(indexOfEditedCellInModel, 1);
                    model.set('errorCells', modelCellErrors, {silent:true});
                }
            }
        },

        allEqualRenew: function(arr) {
            return arr.every(v => v === arr[0]);
        }
    });
})(westcon);
